import {
  init,
  reset,
  setDeviceId,
  setUserId,
  Types,
} from '@amplitude/analytics-browser';

import config from 'config';

const isProd = config.PARTNERS_ENVIRONMENT === 'production';

export function initAmplitude() {
  if (!JSON.parse(config.AMPLITUDE_ENABLED || 'false')) return undefined;

  return init(config.AMPLITUDE_API_KEY, {
    serverZone: 'US',
    logLevel: isProd ? Types.LogLevel.Warn : Types.LogLevel.Debug,
  });
}

export function setAmplitudeUserId(leadId: string | undefined) {
  if (!leadId) return;
  setUserId(leadId);
}

export function setAmplitudeDeviceId(deviceId: string | undefined) {
  if (!deviceId) return;
  setDeviceId(deviceId);
}

export function resetAmplitude() {
  reset();
}
